var render, staticRenderFns
import script from "./RolMixin.vue?vue&type=script&lang=js"
export * from "./RolMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e65e326')) {
      api.createRecord('5e65e326', component.options)
    } else {
      api.reload('5e65e326', component.options)
    }
    
  }
}
component.options.__file = "src/mixins/RolMixin.vue"
export default component.exports